module.exports = __webpack_public_path__ + "ed9b2989176c503773afe5da9b30367d.png";